<template>
  <div>
    <h2>
      Trigger release emails
    </h2>
    <h3 class="text-danger">
      This for sending out release emails associated with the initial release. Unless NAR just went into production and we haven't sent those emails out yet, LEAVE!
    </h3>
    <b-row>
      <b-col>
        <b-button @click="checkbox=!checkbox">{{checkbox?'Nevermind':'I know what I\'m doing'}}</b-button>
      </b-col>
    </b-row>

    <div v-if="checkbox">
      <br/>
      <b-row>
        <b-col>
          <b-button variant="primary" @click="triggerReleaseProviderEmails">Trigger release provider emails</b-button>
        </b-col>
        <b-col v-if="providerWaiting">Working on provider emails, this will take a moment...</b-col>
        <b-col v-if="numberOfProviderEmails">Sent out {{numberOfProviderEmails}} emails to providers.</b-col>
      </b-row>
      <br/>
      <b-row>
        <b-col>
          <b-button variant="primary" @click="triggerReleaseCNAEmails">Trigger release CNA emails</b-button>
        </b-col>
        <b-col v-if="cnaWaiting">Working on cna emails, this will take a moment...</b-col>
        <b-col v-if="numberOfProviderEmails">Sent out {{numberOfCNAEmails}} emails to CNAs.</b-col>
      </b-row>
    </div>
  </div>

</template>

<script>


import axios from "axios";

export default {
  created() {
    document.title = "Release email trigger - NAR"
  },
  components:{
  },
  data(){
    return {
      checkbox: false,
      numberOfProviderEmails: null,
      numberOfCNAEmails: null,
      providerWaiting: false,
      cnaWaiting: false,
    }
  },
  methods:{
    triggerReleaseProviderEmails(){
    this.providerWaiting = true;
      axios.get(`${process.env.VUE_APP_API_BASE_URL}/announcement/provider`)
          .then((response) => {
            this.numberOfProviderEmails = response.data;
          })
          .finally(()=>{
            this.providerWaiting = false;
          })
    },
    triggerReleaseCNAEmails(){
      this.cnaWaiting = true;
      axios.get(`${process.env.VUE_APP_API_BASE_URL}/announcement/cna`)
          .then((response) => {
            this.numberOfCNAEmails = response.data;
          })
          .finally(()=>{
            this.cnaWaiting = false;
          })
    }
  },
  validations:{
    checkbox: {required: false}
  }
}
</script>
